import { accountPageSlugs, basketPageSlugs, checkoutPageSlugs } from '@boss/constants/b2b-b2c';

// [44843] R3 route guard. The server cannot resolve RBAC permissions itself (the
// auth session lives in localStorage), so the client persists the resolved
// permissions in this cookie and the middleware does the silent server-side
// redirect before the static page renders. The client guard (usePermissionGuard)
// stays as the backstop for missing/stale cookies.

export const RBAC_PERMISSION_COOKIE = 'boss-rbac-permissions';

export type RbacPermissions = { showprice: boolean; canorder: boolean };

export const serializePermissionCookie = ({ showprice, canorder }: RbacPermissions): string =>
  `${showprice ? 1 : 0}-${canorder ? 1 : 0}`;

export const parsePermissionCookie = (value: string | undefined): RbacPermissions | null => {
  const match = /^([01])-([01])$/.exec(value ?? '');

  if (!match) {
    return null;
  }

  return { showprice: match[1] === '1', canorder: match[2] === '1' };
};

/**
 * Resolves the server-side redirect for order-guarded routes (winkelmandje,
 * checkout incl. subpaths). `pathname` is locale-stripped, as Next.js exposes it
 * in middleware. Returns the redirect destination or null to let the request pass.
 */
export const resolveCanorderRedirect = (
  pathname: string,
  locale: string,
  cookieValue: string | undefined,
): string | null => {
  const permissions = parsePermissionCookie(cookieValue);

  if (!permissions || permissions.canorder) {
    return null;
  }

  const basketPath = `/${basketPageSlugs[locale]}`;
  const checkoutPath = `/${checkoutPageSlugs[locale]}`;

  const isGuarded = pathname === basketPath || pathname === checkoutPath || pathname.startsWith(`${checkoutPath}/`);

  if (!isGuarded) {
    return null;
  }

  return `/${accountPageSlugs[locale]}`;
};
